module.exports = __webpack_public_path__ + "img/sg-areacode.b3b934dc.png";